import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CONNECTED_TURNAROUND_TEST_IDS } from '@connect-x-app/web-test-ids';
import { Button, ErrorMessage } from '@connect-x-app/web-ui';
import type { UIMessage } from '@tanstack/ai-react';

import { renderParts } from '../parts/partRenderers';

import './ChatMessage.scss';

type Props = {
  index: number;
  isLatest: boolean;
  message: UIMessage;
  onRetry?: () => void;
  showsError: boolean;
};

const questionOf = (message: UIMessage) => message.parts.map(part => (part.type === 'text' ? part.content : '')).join('');

export const ChatMessage = memo(({ index, isLatest, message, onRetry, showsError }: Props) => {
  const { t } = useTranslation();
  const testId = CONNECTED_TURNAROUND_TEST_IDS.messages.row(index);

  if (message.role === 'user') {
    return (
      <p className="chat-message chat-message--question" data-test={testId}>
        {questionOf(message)}
      </p>
    );
  }

  return (
    <div className="chat-message chat-message--answer" data-test={testId}>
      {renderParts(message)}
      {showsError ? (
        <div
          className="chat-message__error"
          data-test={CONNECTED_TURNAROUND_TEST_IDS.messages.error}
          role={isLatest ? 'alert' : undefined}
        >
          <ErrorMessage>{t('CONNECTED_TURNAROUND.ERROR')}</ErrorMessage>
          {onRetry ? (
            <Button isOutline onClick={onRetry} testId={CONNECTED_TURNAROUND_TEST_IDS.messages.retry} theme="dark">
              {t('CONNECTED_TURNAROUND.RETRY')}
            </Button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
});
